import {
  RESET_CHAT,
  FETCHING_CHAT,
  FETCH_CHAT_SUCCESS,
  FETCH_CHAT_FAIL,
  FETCH_ROOM_SUCCESS
} from '../actions/types'

const INITIAL_STATE = {
  loading: false,
  roomData: null,
  messages: null,
  userId: null,
  errorMsg: null
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESET_CHAT:
      return { ...state, ...INITIAL_STATE }
    case FETCHING_CHAT:
      return { ...state, loading: true }
    case FETCH_CHAT_SUCCESS:
      const { messages, userId } = action.payload
      return { ...state, loading: false, messages, userId }
    case FETCH_ROOM_SUCCESS:
      return { ...state, loading: false, roomData: action.payload }
    case FETCH_CHAT_FAIL:
      return { ...state, ...INITIAL_STATE, errorMsg: action.payload }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/activeChatReducer.js